import { footerData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="py-10 md:py-14 px-4 md:px-6 bg-secondary-50 border-t border-background-200/70">
      <div className="w-full max-w-[1120px] mx-auto">
        <div className="flex flex-col md:flex-row gap-8 mb-8">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-lg text-white" style={{ lineHeight: 1 }}></i>
              </div>
              <span className="font-heading text-lg text-foreground-950">包子漫画</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">{footerData.description}</p>
          </div>

          <div className="flex flex-wrap gap-8 md:gap-12">
            <div>
              <div className="text-sm font-medium text-foreground-800 mb-3">快速导航</div>
              <div className="flex flex-col gap-2">
                {footerData.links.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <div className="text-sm font-medium text-foreground-800 mb-3">合作伙伴</div>
              <div className="flex flex-col gap-2">
                <span className="text-sm text-foreground-400">虚位以待</span>
                <span className="text-sm text-foreground-400">诚邀加入</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-6 border-t border-background-200/50 gap-3">
          <span className="text-xs text-foreground-400">{footerData.copyright}</span>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}